import { __awaiter, __extends, __generator } from "tslib";
var LoginFlowState = /** @class */ (function () {
    function LoginFlowState() {
    }
    return LoginFlowState;
}());
export { LoginFlowState };
var LazyComponentState = /** @class */ (function (_super) {
    __extends(LazyComponentState, _super);
    function LazyComponentState(componentImport) {
        var _this = _super.call(this) || this;
        _this.componentImport = componentImport;
        return _this;
    }
    LazyComponentState.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var LazyComponentClass, TargetClass;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('Helper/LazyComponent')];
                    case 1:
                        LazyComponentClass = (_a.sent()).default;
                        return [4 /*yield*/, this.componentImport];
                    case 2:
                        TargetClass = (_a.sent()).default;
                        this.component = new LazyComponentClass(TargetClass, {});
                        this.component.mount();
                        this.component.component.$on('close', function () { return _this.stop(); });
                        document.body.style.overflow = 'hidden';
                        return [2 /*return*/];
                }
            });
        });
    };
    LazyComponentState.prototype.stop = function () {
        this.component.destroy();
        document.body.style.overflow = null;
    };
    return LazyComponentState;
}(LoginFlowState));
export { LazyComponentState };
var LoginFlowManager = /** @class */ (function () {
    function LoginFlowManager() {
    }
    Object.defineProperty(LoginFlowManager, "instance", {
        get: function () {
            if (!LoginFlowManager._instance)
                LoginFlowManager._instance = new LoginFlowManager();
            return LoginFlowManager._instance;
        },
        enumerable: false,
        configurable: true
    });
    LoginFlowManager.prototype.setState = function (state) {
        if (!window['loginActive'])
            return;
        if (this.currentState)
            this.currentState.stop();
        this.currentState = state;
        this.currentState.start();
    };
    LoginFlowManager.prototype.stop = function () {
        if (window['singleSignOn'])
            return LoginFlowManager.instance.setState(LOGIN_FLOW_STATES.LOGIN);
        this.currentState.stop();
    };
    return LoginFlowManager;
}());
export { LoginFlowManager };
export var LOGIN_FLOW_STATES = {
    INFO: new LazyComponentState(import("./CustomerInfo.vue")),
    REMINDER: new LazyComponentState(import("./CustomerReminder.vue")),
    REGISTER: new LazyComponentState(import("./CustomerRegistration.vue")),
    LOGIN: new LazyComponentState(import("./CustomerLogin.vue")),
    LAST_SEEN_BOOKMARKS: new LazyComponentState(import("./CustomerAnonymousBookmarks.vue")),
    WELCOME: new LazyComponentState(import("./CustomerWelcome.vue")),
    PASSWORD_RESET: new LazyComponentState(import("./CustomerPasswordReset.vue")),
};
